import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Copy, Box } from '@elparking/components'

const HeaderBlock = ({ user, cancelled }) => {
    return user
        ? <Box>
            <Copy size='small' fontWeight='regular' color='gray'>
                <FormattedMessage
                  defaultMessage='Gracias, {name}'
                  values={{
                      name: user && user.firstName,
                  }}
                />
            </Copy>
            <Copy size='xxLarge' fontWeight='bold' color='accent_dark80' padding='0.5em 0em'>
                {cancelled
                    ? <FormattedMessage defaultMessage='Tu alquiler ha sido cancelado'/>
                    : <FormattedMessage defaultMessage='Tu reserva se ha realizado correctamente'/>
                }
            </Copy>
        </Box>
        : null
}

HeaderBlock.propTypes = {
    cancelled: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    user: PropTypes.shape({
        firstName: PropTypes.string,
    }),
}

export default HeaderBlock
